import {useEffect, useRef} from 'react';
import {useBreadcrumbsStore} from '../../../entities/breadcrumbs';
import {usePageTitleStore} from '../../../entities/pageTitle';
import {DevicesHead, DevicesTable, DevicesTitle} from '../../../features/devices';
import {useApiariesStore} from '../../../entities/apiaries';
import {useDevicesStore} from '../../../entities/devices/model/store';
import {ApiaryHivesAbsence} from '../../../shared/ui/apiaryHivesAbsence/ApiaryHivesAbsence.tsx';

export const Devices = () => {
  const setCrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  const setTitle = usePageTitleStore((s) => s.setDynamicTitle);
  const apiaryId = useApiariesStore((s) => s.currentApiaryId);
  const getDevicesFromServer = useDevicesStore((s) => s.getDevicesFromServer);
  const prevApiaryIdRef = useRef<string | number | null>(null);

  useEffect(() => {
    setCrumbs([
      {title: 'Моя пасека', url: '/', route: {path: '/'}},
      {title: 'Управление устройствами', url: '/devices', route: {path: '/devices'}},
    ]);

    setTitle(<DevicesTitle />);

    return () => {
      setTitle('');
    };
  }, [setCrumbs, setTitle]);

  useEffect(() => {
    if (apiaryId && prevApiaryIdRef.current !== apiaryId) {
      prevApiaryIdRef.current = apiaryId;
      getDevicesFromServer({apiaryId});
    }
  }, [apiaryId]);

  return (
    <div style={{minHeight: '100%'}}>
      <DevicesHead />

      <ApiaryHivesAbsence>
        <DevicesTable />
      </ApiaryHivesAbsence>
    </div>
  );
};
